module.exports = __webpack_public_path__ + "img/icon_warning.a00975f0.webp";